import React, { useEffect } from "react";
import { Stack, Typography, Box, Button } from "@mui/material";
import IosSwitch from "../../components/IOSSwitch";
import { Images } from "./../../assets/common";
import SikiInput from "../SikiInput";
import { kFormatter } from "../../constants/function";
import { useTranslation } from "react-i18next";
import notifier from "../../components/Notifier";

export default function SetSubscription(props) {
  const { t } = useTranslation("common");
  const [checked, setChecked] = React.useState(false);
  const [fee, setFee] = React.useState("");
  const [isFeeSet, setIsFeeSet] = React.useState(false);
  const handleChange = (value) => {
    console.log(value);
    setChecked(value);
    props.checked(value, fee);
  };

  const handleSetFee = () => {
    if (fee) {
      if (fee == 0) {
        notifier.error(t("notifier.error.toast16"))
      } else {
        props.checked(checked, fee);
        handelFeechange(true);
      }
    }
  };

  const handelFeechange = (b) => {
    setIsFeeSet(b);
    props.changeFee(b);
  };

  useEffect(() => {
    if (
      props["subscription"] &&
      props["subscription"]["subscriptionStatus"] === "enabled"
    ) {
      setIsFeeSet(true);
      setChecked(true);
      setFee(props["subscription"]["subscriptionFee"]);
    }
  }, []);
  return (
    <Stack
      sx={{
        width: "100%",
        borderRadius: "25px",
        minHeight: "80px",
        background: checked && !isFeeSet ? "#000000" : "transparent",
      }}
    >
      <Stack direction="column" padding="6px">
        <Stack
          direction="row"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",

            width: "auto",

            alignItems: "center",
          }}
        >
          {/* <img src={Images.handshake} alt="handshake" /> */}
          <Typography
            sx={{
              color: "#FFFFFF",
              fontSize: 17,
              marginRight: "auto",
            }}
          >
            {t("myProfile.subscription.header")}
          </Typography>
          <IosSwitch checked={checked} handleChange={handleChange} />
        </Stack>
        {checked && isFeeSet ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack direction="column" alignItems="start">
              <Typography className="fs-14">
                {t("myProfile.subscription.subHeader")}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography
                  className="fs-14"
                  sx={{ color: "#ffffff", textDecoration: "none !important" }}
                >
                  {props["subscription"]
                    ? props["subscription"]["subscriptionFee"]
                    : 0}{" "}
                  {t("myProfile.subscription.tokens")}{" "}
                </Typography>
                <Typography
                  color="primary"
                  className="underline _cp fs-14"
                  onClick={() => handelFeechange(false)}
                >
                  {t("myProfile.subscription.button")}
                </Typography>
              </Stack>
            </Stack>
            <Stack direction="column" alignItems="end">
              <Typography className="fs-14">
                {t("myProfile.subscription.subscribers")}
              </Typography>
              <Typography className="fs-14" color="default">
                {props["subscription"] && props["subscription"]["subscribers"]
                  ? kFormatter(props["subscription"]["subscribers"])
                  : ""}
              </Typography>
            </Stack>
          </Stack>
        ) : null}
      </Stack>
      {checked && !isFeeSet ? (
        <Box sx={{ padding: "10px 21px" }}>
          <Stack>
            <SikiInput
              type="number"
              label={t("myProfile.subscription.label")}
              placeholder={t("myProfile.subscription.placeholder")}
              value={fee}
              onChange={(e) => {
                if (e === 0) {
                  notifier.error(t("notifier.error.toast16"))
                } else setFee(e)
              }}
            />
            <Typography variant="body2" mt={1} className="fade-text">
              {t("myProfile.subscription.text1")}
            </Typography>
            <Typography variant="body2" mt={1} className="fade-text">
              {t("myProfile.subscription.text2")}
            </Typography>
            <Button
              onClick={handleSetFee}
              sx={{ marginTop: "1rem" }}
              variant="contained"
              color="primary"
              disabled={fee === "" || fee < 0}
            >
              {t("myProfile.subscription.button1")}
            </Button>
          </Stack>
        </Box>
      ) : null}
      {/* {checked && isFeeSet ? (
        <Box sx={{ padding: "10px 21px" }}>
          <Stack direction="column" spacing={1}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body2" className="fade-text">
                Your Fee /Month{" "}
              </Typography>
              <Typography variant="body2" className="fade-text">
                Your Subscribers{" "}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Box>
                <Typography
                  component="span"
                  variant="body1"
                  className="text-white"
                  sx={{ whiteSpace: "pre", fontWeight: "bold" }}
                >
                  {fee} SIKI COINS{" "}
                </Typography>
                <Typography
                  component="span"
                  variant="body1"
                  color="primary"
                  className="underline _cp"
                  onClick={() => setIsFeeSet(false)}
                >
                  Change
                </Typography>
              </Box>
              <Typography className="text-white fw-b">1.3K </Typography>
            </Stack>
          </Stack>
        </Box>
      ) : null} */}
    </Stack>
  );
}
